import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PensionEstimatedPay } from '../../Models/Domains/Tax/PensionEstimatedPay';
import { PensionEstimatedPayQuery } from '../../Models/Domains/Tax/PensionEstimatedPayQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class EstimatedPayForPensionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(query: PensionEstimatedPayQuery): Promise<PensionEstimatedPay, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Tax/EstimatedPayForPension/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query }

    return AjaxWrapper.post<PensionEstimatedPay, any>(url, data);
  }
}

